// Suppress Lexxy/ActionText node warnings in development
// These warnings occur when Lexxy tries to handle ActionText attachment nodes
// but doesn't have the required methods. They are non-breaking.

// Always suppress these warnings (not just in development) since they're non-breaking
const originalWarn = console.warn;
const originalLog = console.log;

// Override console.warn
console.warn = function(...args) {
  const warningText = args[0]?.toString() || '';
  if (warningText.includes('_ActionTextAttachmentUploadNode') && 
      (warningText.includes('must implement') || 
       warningText.includes('should implement'))) {
    return; // Suppress these specific warnings
  }
  originalWarn.apply(console, args);
};

// Also check console.log in case Lexical uses that
console.log = function(...args) {
  const logText = args[0]?.toString() || '';
  if (logText.includes('_ActionTextAttachmentUploadNode') && 
      (logText.includes('must implement') || 
       logText.includes('should implement'))) {
    return; // Suppress these specific logs
  }
  originalLog.apply(console, args);
};